<!--
 * @Description: 云途-编辑商机
 * @Author: mdb
 * @Date: 2022-07-01 15:31:13
 * @LastEditTime: 2023-06-25 14:26:26
 * @LastEditors: cxh
-->
<template>
  <CosLayoutMain>
    <template #content>
      <BusinessForm ref="businessFormRef" title="编辑商机" type="edit" v-model:value="dataForm" :originalStatus="originalStatus" @update:value="fetch" />
    </template>

    <template #footer>
      <cos-footer-button :loading="loading" v-model:value="dataForm" hideOk :disabled="false" :resetValue="initForm">
        <a-button type="primary" @click="handleSubmit" v-permission="'lbu_business_edit_btn'">保存</a-button>
      </cos-footer-button>
    </template>
  </CosLayoutMain>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { message } from '@dc-platform/dc-components'
import CosLayoutMain from '@/components/CosLayoutMain/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit, businessDetails } from '@/api/yuntuSales/chanceManage'
import type { LbuBusinessEditParams } from '@/typings/api/chanceManage'
const route = useRoute()

const initForm: LbuBusinessEditParams = ref({})
const dataForm = ref<LbuBusinessEditParams>({})
const originalStatus = ref<number>()
onBeforeMount(() => {
  businessDetails({ id: route.query.id }).then((res) => {
    if (!res.data.failedCooperateId) {
      res.data.failedCooperateId = undefined
    }
    if (!res.data.assistDepartment) {
      res.data.assistDepartment = undefined
    }
    originalStatus.value = res.data.status
    dataForm.value = res.data
    initForm.value = cloneDeep(res.data)
  })
})

const fetch = (val: any) => {
  dataForm.value = val
}
const businessFormRef = ref()
const loading = ref(false)
const handleSubmit = () => {
  businessFormRef.value?.validate().then(() => {
    const { status } = dataForm.value

    if (status === 4 || status === 9) {
      const { oprWeight, ocrWeight, oprCube, ocrCube } = dataForm.value
      if (oprWeight && !ocrWeight) {
        message.error('请输入OCR重量')
        return
      } else if (oprCube && !ocrCube) {
        message.error('请输入OCR方数')
        return
      }
    }

    loading.value = true
    const params = dataForm.value
    businessCreateOrEdit(params)
      .then(() => {
        message.success('编辑成功')
        businessFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuBusinessEdit' }
</script>

<style scoped></style>
